import { useCallbackPrompt } from './useCallbackPrompt';

export function Prompt(props) {
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    props.isDirty
  );
  return <div></div>;
}
